import { MessagesSquare } from "lucide-react";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { InvoiceComments } from ".";
import { CommentsCount } from "./comments-count";

type Props = PropsWithChildren<{
  invoiceId: string;
}>;

export const CommentsPopover = ({ invoiceId, children }: Props) => {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        {children ? (
          children
        ) : (
          <Button
            className="gap-1 text-xs px-2 py-0.5 h-6"
            variant="outline"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <MessagesSquare className="h-4 w-4" />
            {t("comments")}
            <CommentsCount invoiceId={invoiceId} size="sm" />
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent
        className="w-80 h-96 overflow-hidden"
        side="right"
        align="start"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <InvoiceComments
          invoiceId={invoiceId}
          className="overflow-auto h-full flex-1"
          disableInput
        />
      </PopoverContent>
    </Popover>
  );
};
